import {
  getLanguage, getStorageCityId, getRegionByCookie, isProd,
} from '@RootCommon/utils'
import { getI18nWebParams } from '@sailor/i18n-utils'

const i18nEnv = isProd() ? 'prod' : 'test'

// 获取门店列表，仅依赖acctId和账号region
// 账号相关的i18n信息(主要为region)就绪, i18n信息依赖门店信息（regin、cityid）
// !!!目前设定：账号region和门店region必须相同（不同则建立不同商家账号）
// 即
export async function getI18nWebParamsApi (params?: {
  locale?: string,
}) {
  let systemLocale = params?.locale || getLanguage()
  try {
    return getI18nWebParams({ clientType: 'b_pc', env: i18nEnv, options: { useSailorCompass: true } }, {
      systemLocale,
      systemRegion: getRegionByCookie(),
      systemTimeZone: 'GMT+08:00', // TODO timezone目前写死，待确定pc获取逻辑。
    })
  } catch (e) {
    console.log(e)
    return {}
  }
}